import React, { useEffect, useRef, useState } from "react";
// import Header from '../header/header'
import { useDispatch, useSelector } from "react-redux";
// import { addPortfolioApi, getServiceApi } from '../../redux/portfolio/portfolio';
import { ArrowDown, ArrowRight, Eye, EyeOff } from "lucide-react";
import toast from "react-hot-toast";
import {
  addPortfolioApi,
  getServiceApi,
  UserPortfolioApi,
} from "../../../redux/portfolio/portfolio";
import { useNavigate } from "react-router-dom";
import Chart from "react-apexcharts";
import { generateSymbolColors } from "../../../components/chartColor";
import Layout from "../../layout/Layout";
import moment from "moment/moment";
import { useDocumentTitle } from "../../../utils/Common";
import { getAlerts } from "../../../api/dashboard";
import { useTheme } from "../../../utils/theme";
import { AllocationModal, PdfModal } from "../../../components/rpfModal";
import { Tooltip } from "bootstrap";
import axios from "axios";

export default function Portfolio() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state.auth.userDetail);
  const portFolioList = useSelector((state) => state.portfolio.portFolioList);
  const userPortfolio = useSelector((state) => state.portfolio.userPortfolio);
  const userPortFolioList = useSelector(
    (state) => state.portfolio.userPortFolioList,
  );
  const dispatch = useDispatch();
  // const [activeTab, setActiveTab] = useState("Porfolio");
  const symbols = userPortfolio?.openStocks?.map((item) => item.scrip) || [];
  const symbolColors = generateSymbolColors(symbols);
  const [showModal, setShowModal] = useState(false);
  const [finalData, setFinalData] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [AlertData, setAlertData] = useState(null);
  const [selectedindex, setSelectedindex] = useState(null);
  const [addedRows, setAddedRows] = useState({});
  const [highlightIndex, setHighlightIndex] = useState(null);
  const [pdfPath, setPdfPath] = useState("");
  const [selectedAllocationStock, setSelectedAllocationStock] = useState(null);
  const [isChartLabelBlurred, setIsChartLabelBlurred] = useState(false);
  const chartRegionRef = useRef(null);
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        position: "right",
        fontSize: "12px",
        width: 150,
        itemMargin: {
          vertical: 6,
        },
        formatter: (seriesName) =>
          seriesName.length > 10 ? `${seriesName.slice(0, 10)}...` : seriesName,
      },
      chart: {
        type: "pie",
      },
      plotOptions: {
        pie: {
          // Offset the whole pie chart
          offsetX: 0,
          offsetY: 20,
          donut: {
            size: "70%", // Adjust donut size for inner space
            labels: {
              show: true, // Show inner labels
              name: {
                show: true,
                fontSize: "13px",
                offsetY: -6,

                // ... other label styles
              },
              value: {
                show: true,
                fontSize: "12px",
                offsetY: 6,
                formatter: (val) =>
                  Number(val).toLocaleString("en-IN", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  }),
                // ... other label styles
              },
            },
          },

          dataLabels: {
            offset: 10,

            // Distance of data labels from pie edge
            // ... other dataLabel settings
          },
        },
      },
    },
  });

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) =>
      Tooltip.getOrCreateInstance(tooltipTriggerEl),
    );

    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, [userPortfolio?.openStocks, userPortfolio?.closedStocks]);
  const [activeTab, setActiveTab] = useState("market");
  const [summaryNews, setSummaryNews] = useState([]);
  const [StockNews, setStockNews] = useState(null);
  const [StockName, setStockName] = useState(null);
  const [StockId, setStockId] = useState(null);

  const tabs = [
    { key: "market", label: "Market Cap" },
    { key: "sectors", label: "Sectors" },
    { key: "stocks", label: "Stocks" },
  ];
  // useEffect(() => {
  //   const list = userPortfolio?.userList;
  //   if (!Array.isArray(list) || list.length === 0) return;

  //   const labels = list.map(item => item.symbol);
  //   const series = list.map(item => Number(item.investedAmt));

  //   setChartData(prev => ({
  //     ...prev,
  //     series,
  //     options: {
  //       ...prev.options,
  //       labels,
  //     },
  //   }));
  // }, [userPortfolio?.userList]);
  useDocumentTitle("Equity Portfolios")
  useEffect(() => {
    const labelColor = theme === "dark" ? "#f8fafc" : "#111827";
    const legendColor = theme === "dark" ? "#e5e7eb" : "#374151";

    setChartData((prev) => ({
      ...prev,
      options: {
        ...prev.options,
        legend: {
          ...prev.options.legend,
          labels: {
            ...prev.options.legend?.labels,
            colors: legendColor,
          },
        },
        plotOptions: {
          ...prev.options.plotOptions,
          pie: {
            ...prev.options.plotOptions?.pie,
            donut: {
              ...prev.options.plotOptions?.pie?.donut,
              labels: {
                ...prev.options.plotOptions?.pie?.donut?.labels,
                name: {
                  ...prev.options.plotOptions?.pie?.donut?.labels?.name,
                  color: labelColor,
                },
                value: {
                  ...prev.options.plotOptions?.pie?.donut?.labels?.value,
                  color: labelColor,
                },
                total: {
                  ...prev.options.plotOptions?.pie?.donut?.labels?.total,
                  color: labelColor,
                },
              },
            },
          },
        },
      },
    }));
  }, [theme]);

  useEffect(() => {
    const chartRegion = chartRegionRef.current;
    if (!chartRegion) return undefined;

    const makeLegendAccessible = () => {
      const legend = chartRegion.querySelector(".apexcharts-legend");
      if (legend) {
        legend.setAttribute("tabindex", "0");
        legend.setAttribute("role", "region");
        legend.setAttribute("aria-label", "Portfolio allocation chart legend");
      }
    };

    makeLegendAccessible();
    const observer = new MutationObserver(makeLegendAccessible);
    observer.observe(chartRegion, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [chartData.series]);

  useEffect(() => {
    const list = userPortfolio?.openStocks;
    if (!Array.isArray(list) || list.length === 0) return;

    const labels = list.map((item) => item.scrip);
    const series = list.map((item) => Number(item.invested));
    const colors = labels.map((symbol) => symbolColors[symbol]);

    setChartData((prev) => ({
      ...prev,
      series,
      options: {
        ...prev.options,
        labels,
        colors, // ✅ FIXED
      },
    }));
  }, [userPortfolio?.openStocks]);

  const modalRef = useRef(null);
  useEffect(() => {
    dispatch(UserPortfolioApi(userDetail?.id));
    // const fetchLiveCalls = async () => {
    //   try {
    //     const alerts = await getAlerts();
    //     setAlertData(alerts.data.filter((item) => item.serName == "EP_ALPHA_INDIA_PORTFOLIO"));
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };
    const fetchLiveCalls = async () => {
      try {
        const alerts = await getAlerts();
        // setAlertData(alerts.data.filter((item) => item.serName == "EP_ALPHA_INDIA_PORTFOLIO"));
        const filteredData = (alerts?.data || []).filter(
          (item) => item.serName === "EP_ALPHA_INDIA_PORTFOLIO"
        );
        const mergedData = [
          ...(userPortfolio?.alerts || []),
          ...filteredData
        ];

        setAlertData(mergedData);
      } catch (error) {
        console.error(error);
      }
    };
    fetchLiveCalls();
  }, []);
  const handleSave = async (finalData) => {
    try {
      const result = await dispatch(addPortfolioApi(finalData));
      if (result) {
        // dispatch(getServiceApi(userDetail?.id));
        dispatch(UserPortfolioApi(userDetail?.id));
        toast.success(result?.payload?.message);
        setShowModal(false);
        setHighlightIndex(selectedindex);
        setEditIndex(null);
        setTimeout(() => {
          setHighlightIndex(null);
        }, 700);
      }
    } catch (error) {
      console.error("Error adding portfolio:", error);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal]);

  const [inputs, setInputs] = useState({});
  const [errors, setErrors] = useState({});
  const handleInputChange = (index, field, value, recomQty) => {
    const numValue = Number(value);
    setSelectedindex(index ? index : null);
    if (numValue < 0) {
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: "Value cannot be negative",
        },
      }));
      return; // stop here, don't update inputs
    }

    // if (recomQty && numValue > Number(recomQty) && field != "price") {
    //   // ❌ Greater than recommended qty not allowed
    //   setErrors((prev) => ({
    //     ...prev,
    //     [index]: {
    //       ...prev[index],
    //       [field]: `Value should not exceed ${recomQty}`,
    //     },
    //   }));
    //   return; // stop here, don't update inputs
    // }

    // ✅ Passed validation → update inputs and clear errors
    setInputs((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: "",
      },
    }));
  };

  // const handleInputChange = (index, field, value, recomQty) => {
  //   setInputs((prev) => ({
  //     ...prev,
  //     [index]: {
  //       ...prev[index],
  //       [field]: value,
  //     },
  //   }));

  //   // Clear error on change
  //   setErrors((prev) => ({
  //     ...prev,
  //     [index]: {
  //       ...prev[index],
  //       [field]: "",
  //     },
  //   }));
  // };
  const handleAdd = async (stock, index, isInitial, mode) => {
    const stockInput = inputs[index] || {};
    // const qty = parseFloat(stockInput.qty);
    // const price = parseFloat(stockInput.price);
    // const qty = parseFloat(String(stockInput.qty || "").replace(/,/g, ""));
    const price = parseFloat(String(stockInput.price || "").replace(/,/g, ""));
    let isValid = true;
    const validationErrors = {};

    // if (!qty || isNaN(qty) || qty <= 0) {
    //   validationErrors.qty = "Enter a valid quantity";
    //   isValid = false;
    // }
    // if (!qty || isNaN(qty) || qty <= stock.qty) {
    //   validationErrors.qty = "Enter a valid quantity";
    //   isValid = false;
    // }

    if (!price || isNaN(price) || price <= 0) {
      validationErrors.price = "Enter a valid buying price";
      isValid = false;
    }

    if (!isValid) {
      setErrors((prev) => ({
        ...prev,
        [index]: validationErrors,
      }));
      return;
    }

    // Clear errors
    setErrors((prev) => ({
      ...prev,
      [index]: {},
    }));

    // Build final data
    const finalData = {
      investedAmt: price * (stock.qty || stock?.recQty),
      allocation: stock.allocation,
      portfolioId: isInitial ? stock.portfolioId : stock.id,
      coCode: stock.coCode,
      symbol: stock.symbol,
      avgPrice: price,
      qty: stock.qty || stock?.recQty,
      isInitial: isInitial,
      id: stock.id,
    };
    setFinalData(finalData);
    setShowModal(true);

    // ✅ Mark row as added so it won’t show Add button again
    if (mode === "add") {
      setAddedRows((prev) => ({ ...prev, [index]: true }));
    }

    // Clear inputs after action
    setInputs((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };

  // const handleAdd = async (stock, index, isInitial, mode) => {
  //   const stockInput = inputs[index] || {};
  //   const qty = parseFloat(stockInput.qty);
  //   const price = parseFloat(stockInput.price);

  //   let isValid = true;
  //   const validationErrors = {};

  //   // Validate Quantity
  //   if (!qty || isNaN(qty) || qty <= 0) {
  //     validationErrors.qty = "Enter a valid quantity";
  //     isValid = false;
  //   }

  //   // Validate Price
  //   if (!price || isNaN(price) || price <= 0) {
  //     validationErrors.price = "Enter a valid buying price";
  //     isValid = false;
  //   }

  //   if (!isValid) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [index]: validationErrors,
  //     }));
  //     return;
  //   }

  //   // Clear previous errors
  //   setErrors((prev) => ({
  //     ...prev,
  //     [index]: {},
  //   }));

  //   // Build and extract only required data fields

  //   const finalData = {
  //     investedAmt: mode == "edit" ? 0 : price * qty,
  //     allocation: stock.allocation,
  //     portfolioId: isInitial ? stock.portfolioId : stock.id,
  //     coCode: stock.coCode,
  //     symbol: stock.symbol,
  //     avgPrice: price,
  //     qty: qty,
  //     isInitial: isInitial,
  //     id: stock.id,
  //     // userId: userDetail.id
  //   };
  //   setFinalData(finalData);
  //   setShowModal(true);

  //   // Clear inputs
  //   setInputs((prev) => ({
  //     ...prev,
  //     [index]: { qty: "", price: "" },
  //   }));
  // };

  const openStocks =
    userPortfolio?.openStocks?.map((s) => ({
      id: s.coCode,
      symbol: s.scrip,
      qty: s.qty,
      invested: s.invested,
      currentVal: s.currentVal,
      recomPrice: s.avgPrice,
      ltp: s.cmp,
      todayPLVal: s.dayPnlAmt,
      todayPLPer: s.dayPnlPer,
      overallPLVal: s.currentPnlAmt,
      overallPLPer: s.currentPnlPer,
      pdfPath: s.pdfPath,
      allocationList: Array.isArray(s.allocationList) ? s.allocationList : [],
    })) || [];
  const closedStocks =
    userPortfolio?.closedStocks?.map((s) => ({
      id: s.coCode,
      symbol: s.scrip,
      qty: s.qty,
      invested: s.invested,
      currentVal: s.currentVal,
      recomPrice: s.avgPrice,
      ltp: s.cmp,
      todayPLVal: s.dayPnlAmt,
      todayPLPer: s.dayPnlPer,
      overallPLVal: s.currentPnlAmt,
      overallPLPer: s.currentPnlPer,
    })) || [];

  const handleCallNews = async (stock) => {
    setStockName(stock.symbol);
    setStockId(stock.id);
    const getSummaryNews = await axios.get(`https://uapi.equitypandit.com/serve/api/v1/announcements/get-corpevent-summary?cocode=${stock.id}`
    )
    setSummaryNews(getSummaryNews.data.data)
  }
  const handleNews = async (corpactId) => {

    const getNews = await axios.get(`https://uapi.equitypandit.com/serve/api/v1/announcements/get-corpevent-details?currentPage=1&corpact_id=${corpactId}&cocode=${StockId}`);

    setStockNews(getNews.data.data)
  }
  return (
    <Layout>
      <div className="text-body-emphasis">
        {/* {userDetail?.isPortfolioRegCompleted ? ( */}
        <>
          {/* ===== This is new design ===== */}
          <section id="user-portfolio" className="py-4">
            <div className="container">
              <div className="row justify-content-center justify-content-md-between g-3 align-items-center mb-5">
                <div class="col-md-12">
                  <a
                    href="/dashboard"
                    class="text-decoration-none text-body-emphasis fs-5"
                    aria-label="Back to dashboard"
                  >
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                  </a>
                </div>
                <div className="col-md-8">
                  <div class="row g-3 align-items-center summary-stats-row">
                    <div class="col-md-12">
                      <div class="d-flex justify-content-start align-items-start gap-3">
                        <div>
                          <h4 class="mb-1 fw-bold">Equity Portfolio</h4>
                          <small class="fw-normal text-muted">
                            {userPortfolio?.allocatedFundPer}% Allocation
                          </small>
                        </div>
                        <button
                          class="btn btn-outline-dark btn-sm"
                          onClick={() => {
                            navigate("/my-account");
                            localStorage.removeItem("selectedPortfolio");
                          }}
                        >
                          <i class="fa fa-plus-circle" aria-hidden="true"></i>{" "}
                          <span class="mb-1">
                            <small>Add Funds</small>
                          </span>
                        </button>
                        <button
                          type="button"
                          className={`btn btn-outline-dark btn-sm portfolio-eye-toggle ${theme === "dark" ? "text-light border-light" : ""}`}
                          aria-label={
                            isChartLabelBlurred
                              ? "Show chart labels"
                              : "Blur chart labels"
                          }
                          title={
                            isChartLabelBlurred
                              ? "Show chart labels"
                              : "Blur chart labels"
                          }
                          onClick={() =>
                            setIsChartLabelBlurred((prev) => !prev)
                          }
                        >
                          {isChartLabelBlurred ? (
                            <EyeOff size={16} strokeWidth={2} />
                          ) : (
                            <Eye size={16} strokeWidth={2} />
                          )}
                        </button>
                      </div>
                    </div>
                    {/* </div> */}
                    {/* <small class="fw-normal text-muted d-block mb-4">({userPortfolio?.openStocks?.length > 0
                      ? userPortfolio?.openStocks?.length
                      : 0} {" "} Stocks)</small> */}
                    {/* <div className="row g-3 align-items-center"> */}
                    <div className="col-md-3 col-6 d-none">
                      <small className="text-muted d-block">
                        Allocated Fund
                      </small>
                      <h4 className="mb-0">
                        {userPortfolio?.portfolioAmt?.toLocaleString("en-IN")}
                      </h4>
                    </div>
                    <div className="col-md-3 col-6 summary-metric">
                      <small className="text-muted d-block">Invested</small>
                      <h4 className="mb-0">
                        {userPortfolio?.invested?.toLocaleString("en-IN")}
                      </h4>
                    </div>
                    <div className="col-md-3 col-6 d-none">
                      <small className="text-muted d-block">
                        Available Funds
                      </small>
                      <h4 className="mb-0">
                        {(
                          userPortfolio?.portfolioAmt -
                          userPortfolio?.totalInvestedAmt
                        )?.toLocaleString("en-IN")}
                      </h4>
                    </div>
                    <div className="col-md-3 col-6 summary-metric">
                      <small className="text-muted d-block">
                        Current Value
                      </small>
                      <h4 className="mb-0">
                        {userPortfolio?.currentVal?.toLocaleString("en-IN")}
                      </h4>
                    </div>
                    <div className="col-md-3 col-6 summary-metric">
                      <small className="text-muted d-block">Current P&L</small>
                      <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                        <h4
                          className={`summary-metric-amount ${userPortfolio?.currentPnlAmt >= 0 ? "text-success" : "text-danger"} mb-0`}
                        >
                          {userPortfolio?.currentPnlAmt >= 0 ? "" : "-"}
                          {/* {userPortfolio?.currentPnlAmt?.toFixed(2)} */}
                          {Math.abs(
                            userPortfolio?.currentPnlAmt || 0,
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </h4>
                        <small
                          className={`summary-metric-percent ${userPortfolio?.currentPnlAmt >= 0 ? "text-success" : "text-danger"}`}
                        >
                          ({userPortfolio?.currentPnlPer || 0}%)
                        </small>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 summary-metric">
                      <small className="text-muted d-block">Day's P&L</small>
                      <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                        <h4
                          className={`${userPortfolio?.dayPnlAmt >= 0 ? "text-success" : "text-danger"} mb-0`}
                        >
                          {userPortfolio?.dayPnlAmt >= 0 ? "" : "-"}
                          {/* {userPortfolio?.dayPnlAmt?.toFixed(2)} */}
                          {Math.abs(
                            userPortfolio?.dayPnlAmt || 0,
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </h4>
                        <small
                          className={`${userPortfolio?.dayPnlAmt >= 0 ? "text-success" : "text-danger"}`}
                        >
                          ({userPortfolio?.dayPnlPer || 0}%)
                        </small>
                      </div>
                    </div>
                    <div className="col-md-3 col-6 summary-metric">
                      <small className="text-muted d-block">Booked P&L</small>
                      <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                        <h4
                          className={`${userPortfolio?.bookedPnl >= 0 ? "text-success" : "text-danger"} mb-0`}
                        >
                          {userPortfolio?.bookedPnl >= 0 ? "" : "-"}
                          {/* {userPortfolio?.bookedPnl?.toFixed(2)} */}
                          {Math.abs(
                            userPortfolio?.bookedPnl || 0,
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </h4>
                        {/* <small className={`${userPortfolio?.dayPnlAmt >= 0 ? "text-success" : "text-danger"}`}>({userPortfolio?.todayNetChange || 0}%)</small> */}
                      </div>
                    </div>
                    <div className="col-md-3 col-6 summary-metric">
                      <small className="text-muted d-block">Overall P&L</small>
                      <div className="d-flex align-items-baseline gap-2 summary-metric-value">
                        <h4
                          className={`${userPortfolio?.overallPnl >= 0 ? "text-success" : "text-danger"} mb-0`}
                        >
                          {userPortfolio?.overallPnl >= 0 ? "" : "-"}
                          {/* {userPortfolio?.overallPnl?.toFixed(2)} */}
                          {Math.abs(
                            userPortfolio?.overallPnl || 0,
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </h4>
                        {/* <small
                          className={`${userPortfolio?.totalPnL >= 0 ? "text-success" : "text-danger"}`}
                        >
                          ({userPortfolio?.totalNetChange || 0})
                        </small> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <!-- Pie chart --> */}
                <div className="col-md-4">

                  <div
                    ref={chartRegionRef}
                    className={
                      isChartLabelBlurred
                        ? "portfolio-chart-labels-blurred"
                        : ""
                    }
                  >
                    <Chart
                      options={chartData.options}
                      series={chartData.series}
                      type="donut"
                      height={260}
                      width="100%" fetchLiveCalls
                    />
                  </div>
                </div>

                {/* <!-- Legend --> */}
                {/* <div className="col-md-2 col-6">
                  <div id="portfolioPieLegend" className="pie-legend ms-md-2 mt-3 mt-md-0"></div>
                </div> */}
              </div>
              {AlertData?.length > 0 &&
                <>
                  <h6 class="fw-bold my-3">
                    <i class="fa fa-bell" aria-hidden="true"></i> Recent
                    Alerts
                  </h6>
                  {/* {AlertData?.map((stock, index) => (
                    <>
                      {stock.type == "" && (
                        <div className="alert alert-primary d-inline-block">
                          <small className="mb-0">
                          
                            {stock.serMsg}
                          </small>
                        </div>
                      )}
                      {stock.type == "buy" && (
                        <div className="alert alert-primary d-inline-block">
                          <small className="mb-0">
                            <i className="fa fa-triangle-exclamation"></i>{" "}
                            {stock.serMsg}
                          </small>
                        </div>
                      )}
                      {stock.type == "sell" && (
                        <div className="alert alert-warning d-inline-block">
                          <small className="mb-0">
                            <i className="fa fa-triangle-exclamation"></i>{" "}
                            {stock.serMsg}
                          </small>
                        </div>
                      )}
                      {stock.type == "allocateFund" && (
                        <div
                          class="d-inline-block alert alert-success uni-cursor-pointer"
                          onClick={() => {
                            navigate("/fund-allocation");
                            localStorage.setItem("allocationId", stock.id);
                          }}
                        >
                         
                          <small class="mb-0">
                            <i
                              class="fa fa-triangle-exclamation"
                              aria-hidden="true"
                            ></i>{" "}
                            {stock.msg} , Amt : {stock?.amt}
                          </small>
                          <i class="fa-solid fa-arrow-right ms-2 "></i>
                         
                        </div>
                      )}
                    </>
                  ))} */}
                  {AlertData?.map((stock, index) => (
                    <>
                      {stock.type == "" && (
                        <div className="alert alert-primary d-inline-block">
                          <small className="mb-0">
                            {/* <i className="fa fa-triangle-exclamation"></i>{" "} */}
                            {stock.serMsg}
                          </small>
                        </div>
                      )}
                      {stock.type == "buy" && (
                        <div className="alert alert-primary d-inline-block me-2">
                          <small className="mb-0">
                            <i className="fa fa-triangle-exclamation"></i>{" "}
                            {stock.serMsg || stock.msg}
                          </small>
                        </div>
                      )}
                      {stock.type == "sell" && (
                        <div className="alert alert-warning d-inline-block">
                          <small className="mb-0">
                            <i className="fa fa-triangle-exclamation"></i>{" "}
                            {stock.serMsg || stock.msg}
                          </small>
                        </div>
                      )}
                      {stock.type == "allocateFund" && (
                        <div
                          class="d-inline-block alert alert-success uni-cursor-pointer"
                          onClick={() => {
                            navigate("/fund-allocation");
                            localStorage.setItem("allocationId", stock.id);
                          }}
                        >
                          {/* <div class="row g-3 justify-content-center align-items-center">
                            <div class="col-md-7 col-12">*/}
                          {/* <div class="d-flex gap-3 justify-content-between align-items-center"> */}
                          <small class="mb-0">
                            <i
                              class="fa fa-triangle-exclamation"
                              aria-hidden="true"
                            ></i>{" "}
                            {stock.msg} , Amt : {stock?.amt}
                          </small>
                          <i class="fa-solid fa-arrow-right ms-2 "></i>
                          {/* </div> */}
                          {/* </div>
                            <div class="col-md-5"> */}
                          {/* <div class="d-flex gap-2 justify-content-md-end justify-content-center"> */}
                          {/* <p class="mb-0 pt-1">Amt : {stock?.amt}</p> */}
                          {/* <a href="./fund-allocation.php" class="btn btn-sm btn-dark">Allocate Now</a> */}
                          {/* </div>
                            </div> */}
                          {/* </div> */}
                        </div>
                      )}
                    </>
                  ))}
                </>
              }

              {/* <!-- Table header (desktop) --> */}
              <div className="p-3 rounded-3 bg-dark text-light d-none ">
                <div className="row g-3">
                  <div className="col-md-1">
                    <span>Scrip</span>
                  </div>
                  <div className="col-md-2 text-end">
                    <span>Invested</span>
                  </div>
                  <div className="col-md-2 text-end">
                    <span>Current Val.</span>
                  </div>
                  <div className="col-md-2 text-end">
                    <span>Avg. Price</span>
                  </div>
                  <div className="col-md-2 text-end">
                    <span>Total P&L</span>
                  </div>
                  <div className="col-md-1 text-end">
                    <span>CMP</span>
                  </div>
                  <div className="col-md-2 text-end">
                    <span>1 Day P&L</span>
                  </div>
                </div>
              </div>

              {/* <!-- Rows --> */}
              {userPortFolioList?.length > 0 &&
                userPortFolioList.map((stock, idx) => (
                  <div
                    className="p-3 d-none rounded-3 bg-light text-dark my-2"
                    key={idx}
                  >
                    <div className="row g-2 align-items-center">
                      <div className="col-md-1 col-12">
                        <div className="d-flex align-items-center gap-2 me-2">
                          <i
                            className="fa fa-circle"
                            style={{
                              color: symbolColors[stock.symbol],
                              fontSize: "10px",
                            }}
                          ></i>

                          <span
                            className={
                              isChartLabelBlurred
                                ? "portfolio-sensitive-label-blurred"
                                : ""
                            }
                          >
                            {stock.symbol}
                          </span>
                        </div>
                        <small className="d-block">
                          <small className="text-muted d-block">
                            <i className="fas fa-briefcase"></i>{" "}
                            {stock.qty?.toLocaleString("en-IN")}
                          </small>
                        </small>
                      </div>
                      <div className="col-md-2 col-6">
                        <div className="text-start text-md-end">
                          <small>
                            <small className="d-block d-md-none text-muted">
                              Invested
                            </small>
                          </small>
                          <span>
                            {stock.investedAmt != null
                              ? Number(stock.investedAmt).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                },
                              )
                              : "--"}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-2 col-6">
                        <div className="text-end">
                          <small>
                            <small className="d-block d-md-none text-muted">
                              Current Val.
                            </small>
                          </small>
                          <span>
                            {stock.currentValue != null
                              ? Number(stock.currentValue).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                },
                              )
                              : "--"}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-2 col-4">
                        <div className="text-start text-md-end">
                          {/* Mobile Label */}
                          <small className="d-block d-md-none text-muted mb-1">
                            Avg. Price
                          </small>

                          {editIndex === idx ? (
                            <div className="d-flex align-items-center justify-content-start gap-2">
                              <div>
                                <input
                                  type="number"
                                  className={`form-control form-control-sm text-end ${errors[idx]?.price ? "is-invalid" : ""
                                    }`}
                                  style={{ width: "120px" }}
                                  value={inputs[idx]?.price ?? stock.avgPrice}
                                  onChange={(e) =>
                                    handleInputChange(
                                      idx,
                                      "price",
                                      e.target.value,
                                      Math.floor(
                                        stock.allocation_amount / stock.ltp,
                                      ),
                                    )
                                  }
                                />
                              </div>

                              {/* Save Button */}
                              {/* <button
                              type="button"
                              className="btn btn-sm text-success"
                              onClick={() => {
                                const finalData = {
                                  investedAmt: inputs[idx]?.price * (stock.qty || stock?.recQty),
                                  allocation: stock.allocation,
                                  portfolioId: stock.portfolioId,
                                  coCode: stock.coCode,
                                  symbol: stock.symbol,
                                  avgPrice: inputs[idx]?.price,
                                  qty: (stock.qty || stock?.recQty),
                                  id: stock.id,
                                  isInitial: true
                                };
                                handleSave(finalData)
                              }}
                            >
                              <span>

                                <i className="fa fa-save"></i>
                              </span>
                            </button> */}
                              <button
                                type="button"
                                className="btn btn-sm btn-link text-success p-2"
                                style={{
                                  minWidth: "40px",
                                  minHeight: "40px",
                                  zIndex: 10,
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();

                                  const finalData = {
                                    investedAmt:
                                      inputs[idx]?.price *
                                      (stock.qty || stock?.recQty),
                                    allocation: stock.allocation,
                                    portfolioId: stock.portfolioId,
                                    coCode: stock.coCode,
                                    symbol: stock.symbol,
                                    avgPrice: inputs[idx]?.price,
                                    qty: stock.qty || stock?.recQty,
                                    id: stock.id,
                                    isInitial: true,
                                  };

                                  handleSave(finalData);
                                }}
                              >
                                <i className="fa fa-save fs-5"></i>
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex align-items-center justify-content-md-end gap-2">
                              {/* Price Display */}
                              <span>
                                {stock.avgPrice?.toLocaleString("en-IN")}
                              </span>

                              {/* Edit Button */}
                              {/* <button
                              type="button"
                              className="btn btn-sm text-primary"
                              title="Edit"
                              onClick={() => {
                                setInputs((prev) => ({
                                  ...prev,
                                  [idx]: { price: stock.avgPrice, qty: stock.qty },
                                }));
                                setEditIndex(idx);
                              }}
                            >
                              <i className="fa fa-edit"></i>
                            </button> */}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-2 col-8">
                        <div className="text-end">
                          <small>
                            <small className="d-block d-md-none text-muted">
                              Total P&L
                            </small>
                          </small>
                          <span
                            className={`${stock.pnl > 0 ? "text-success" : "text-danger"}`}
                          >
                            {stock.pnl != null
                              ? Number(stock.pnl).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : "--"}
                            <br className="d-none d-md-block" />
                            <small>
                              <small
                                className={`${stock?.netChange >= 0 ? "text-success" : "text-danger"}`}
                              >
                                (
                                {stock.netChange != null
                                  ? Number(stock.netChange).toFixed(2)
                                  : "--"}
                                %){" "}
                                <i
                                  className={
                                    stock?.netChange >= 0
                                      ? "fa fa-caret-up"
                                      : "fa fa-caret-down"
                                  }
                                ></i>
                              </small>
                            </small>
                          </span>
                        </div>
                      </div>
                      <div className="col-md-1 col-4">
                        <div className="text-start text-md-end">
                          <small>
                            <small className="d-block d-md-none text-muted">
                              CMP
                            </small>
                          </small>
                          <span>{stock.ltp?.toLocaleString("en-IN")}</span>
                        </div>
                      </div>
                      <div className="col-md-2 col-8">
                        <div className="text-end">
                          <small>
                            <small className="d-block d-md-none text-muted">
                              Total P&L
                            </small>
                          </small>
                          <span
                            className={`${stock?.dayChange?.amount > 0 ? "text-success" : "text-danger"}`}
                          >
                            {stock?.dayChange?.amount != null
                              ? Number(stock?.dayChange?.amount).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                },
                              )
                              : "--"}
                            <br className="d-none d-md-block" />
                            <small>
                              <small
                                className={`${stock?.dayChange?.percent >= 0 ? "text-success" : "text-danger"}`}
                              >
                                (
                                {stock?.dayChange?.percent != null
                                  ? Number(stock?.dayChange?.percent).toFixed(2)
                                  : "--"}
                                %){" "}
                                <i
                                  className={
                                    stock?.dayChange?.percent >= 0
                                      ? "fa fa-caret-up"
                                      : "fa fa-caret-down"
                                  }
                                ></i>
                              </small>
                            </small>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              <div class="d-flex align-items-baseline">
                <h5 class="mb-1 fw-bold">Open Recommendations</h5>
                <small class="text-muted ms-2">
                  ({openStocks.length} {openStocks.length > 1 ? "Stocks" : "Stock"})
                </small>
              </div>
              <small class="fw-normal text-muted d-block mb-3">
                As on {moment().format("DD MMM, YYYY")}
              </small>

              <div className="col-12 mt-2">
                {openStocks.length > 0 ? (
                  <div>
                    {/* Header */}
                    <div
                      className={`p-3 rounded-3 d-none d-md-block ${theme === "dark" ? "text-light" : " text-dark"
                        }`}
                      style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                    >
                      {/* <div className="p-3 rounded-3 bg-dark text-light d-none d-md-block"> */}
                      <div className="row g-3 small portfolio-table-row">
                        <div className="col-md-3">Scrip</div>
                        {/* <div className="col-md-1">Market Actions</div> */}
                        <div className="col-md-1 text-end">Invested</div>
                        <div className="col-md-1 text-end">Current Val.</div>
                        <div className="col-md-1 text-end">Avg. Price</div>
                        <div className="col-md-1 text-end">CMP</div>
                        <div className="col-md-2 text-end">1 Day P&L</div>
                        <div className="col-md-2 text-end">Total P&L</div>
                      </div>
                    </div>

                    {openStocks.map((stock, idx) => (
                      // <div
                      //   key={idx}
                      //   className="p-3 rounded-3 bg-light text-dark my-2"
                      // >
                      <div
                        key={idx}
                        className={`p-3 rounded-3 my-2 ${theme === "dark" ? "text-light" : "bg-light text-dark"
                          }`}
                        style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                      >
                        <div className="row g-2 align-items-center portfolio-table-row">
                          {/* Scrip */}
                          <div className="col-md-3 col-12">
                            <div className="">
                              <i
                                className="fa fa-circle fa-2xs me-2"
                                style={{
                                  color: symbolColors[stock.symbol],
                                  // fontSize: "10px",
                                }}
                              ></i>
                              <span
                                className={
                                  isChartLabelBlurred
                                    ? "portfolio-sensitive-label-blurred"
                                    : ""
                                }
                              >
                                {stock.symbol}
                              </span>
                              {stock.pdfPath && (
                                <button
                                  type="button"
                                  className="report-icon-button ms-2"
                                  title="View report"
                                  aria-label={`View report for ${stock.symbol}`}
                                  data-bs-toggle="modal"
                                  data-bs-placement="top"
                                  data-bs-target="#pdfModal"
                                  onClick={() => setPdfPath(stock.pdfPath)}
                                >
                                  <i
                                    className="far fa-file-pdf"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              )}
                              {stock.allocationList?.length > 1 && (
                                <button
                                  type="button"
                                  className={`btn btn-sm border-0  ms-2 ${theme === "dark" ? "text-light" : "text-dark"}`}
                                  aria-label="View allocation list"
                                  data-bs-toggle="modal"
                                  data-bs-target="#allocationModal"
                                  onClick={() => setSelectedAllocationStock(stock)}
                                >
                                  <i className="fa fa-ellipsis-v"></i>
                                </button>
                              )}
                              <br class="d-none d-md-block" />
                              <small className="ms-2">
                                <small className="text-muted">
                                  <i className="fas fa-briefcase"></i>{" "}
                                  {stock.qty?.toLocaleString("en-IN")} Shares
                                </small>
                              </small>
                            </div>
                          </div>
                          {/* News */}
                          {/* <div className="col-md-1 col-6">
                            <div class="text-start text-md-center">
                              <small>
                                <small className="d-block d-md-none text-muted">
                                  News
                                </small>
                              </small>
                              <span
                                title="View News"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                              >
                                <i
                                  className="fa-regular fa-file ms-2"
                                  style={{ cursor: "pointer" }}
                                  aria-label="View News"
                                  data-bs-toggle="modal"
                                  data-bs-target="#newModal"
                                  onClick={() => handleCallNews(stock)}
                                ></i>
                              </span>
                            </div>
                          </div> */}
                          {/* Invested & Current */}
                          <div className="col-md-2 col-6 d-md-none">
                            <div class="text-start text-md-end">
                              <small>
                                <small className="d-block d-md-none text-muted">
                                  Invested
                                </small>
                              </small>
                              <span
                                className={
                                  stock.currentVal >= stock.invested
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.invested.toFixed(2)}
                              </span>
                              <small class="d-block mt-2 mt-md-0">
                                <small class="d-block d-md-none text-muted">
                                  Current Val.
                                </small>
                              </small>
                              <span
                                className={
                                  stock.currentVal >= stock.invested
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.currentVal.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-1 d-none d-md-block">
                            <div class="text-end">
                              <span
                                className={
                                  stock.currentVal >= stock.invested
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.invested.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-1 d-none d-md-block">
                            <div class="text-end">
                              <span
                                className={
                                  stock.currentVal >= stock.invested
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.currentVal.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          {/* Avg & CMP */}
                          <div className="col-md-2 col-6 d-md-none">
                            <div class="text-end">
                              <small>
                                <small class="d-block d-md-none text-muted">
                                  Avg. Price{" "}
                                </small>
                              </small>
                              <span
                                className={
                                  stock.ltp >= stock.recomPrice
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.recomPrice.toFixed(2)}
                              </span>
                              <small class="d-block mt-2 mt-md-0">
                                <small class="d-block d-md-none text-muted">
                                  CMP
                                </small>
                              </small>
                              <span
                                className={
                                  stock.ltp >= stock.recomPrice
                                    ? "text-success d-block"
                                    : "text-danger d-block"
                                }
                              >
                                {stock.ltp.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-1 d-none d-md-block">
                            <div class="text-end">
                              <span
                                className={
                                  stock.ltp >= stock.recomPrice
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.recomPrice.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-1 d-none d-md-block">
                            <div class="text-end">
                              <span
                                className={
                                  stock.ltp >= stock.recomPrice
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.ltp.toFixed(2)}
                              </span>
                            </div>
                          </div>
                          {/* Day P&L */}
                          <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                              <small>
                                <small class="d-block d-md-none text-muted">
                                  1 Day P&L
                                </small>
                              </small>
                              <span
                                className={
                                  stock.todayPLVal >= 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.todayPLVal.toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                })}
                                <br />
                                <small>
                                  ({stock.todayPLPer.toFixed(2)}%)
                                  <i
                                    className={`fa fa-caret-${stock.todayPLPer >= 0 ? "up" : "down"}`}
                                  ></i>
                                </small>
                              </span>
                            </div>
                          </div>
                          {/* Total P&L */}
                          <div class="col-md-2 col-6">
                            <div class="text-end">
                              <small>
                                <small class="d-block d-md-none text-muted">
                                  Total P&amp;L
                                </small>
                              </small>
                              <span
                                className={
                                  stock.overallPLVal >= 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {stock.overallPLVal.toLocaleString("en-IN", {
                                  minimumFractionDigits: 2,
                                })}
                                <br />
                                <small>
                                  ({stock.overallPLPer.toFixed(2)}%)
                                  <i
                                    className={`fa fa-caret-${stock.overallPLPer >= 0 ? "up" : "down"}`}
                                  ></i>
                                </small>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">
                    All recommendations and the P&L summary are displayed here.
                  </div>
                )}
              </div>
              <div class="d-flex align-items-baseline mt-3">
                <h5 class="mb-1 fw-bold">Closed Recommendations</h5>
                <small class="text-muted ms-2">
                  ({closedStocks.length} {closedStocks.length > 1 ? "Stocks" : "Stock"})
                </small>
              </div>
              <div className="col-12 mt-2">
                {closedStocks.length > 0 ? (
                  <div>
                    {/* Header */}
                    <div
                      className={`p-3 rounded-3 d-none d-md-block ${theme === "dark" ? "text-light" : "bg-white text-dark"
                        }`}
                      style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                    >
                      {/* <div className="p-3 rounded-3 bg-dark text-light d-none d-md-block"> */}
                      <div className="row g-3 small">
                        <div className="col-md-3">Scrip</div>
                        <div className="col-md-1 text-end">Qty</div>

                        <div className="col-md-2 text-end">Avg. Price</div>
                        <div className="col-md-2 text-end">Exit Price</div>
                        <div className="col-md-2 text-end">Exit Date</div>
                        <div className="col-md-2 text-end">Booked P&L</div>
                      </div>
                    </div>

                    {userPortfolio?.closedStocks?.length > 0 && (
                      <div className="">
                        {userPortfolio?.closedStocks?.map((stock, idx) => (
                          // <div
                          //   key={idx}
                          //   className="p-3 rounded-3 bg-light text-dark my-2"
                          // >
                          <div
                            key={idx}
                            className={`p-3 rounded-3 my-2 ${theme === "dark" ? "text-light" : "bg-light text-dark"
                              }`}
                            style={theme === "dark" ? { backgroundColor: "#0A0A0B" } : {}}
                          >
                            <div className="row g-2 align-items-center">
                              {/* Scrip */}
                              <div className="col-md-3 col-12">
                                <div className="d-flex align-items-center gap-2">
                                  <i
                                    className="fa fa-circle"
                                    style={{
                                      color: symbolColors[stock.scrip],
                                      fontSize: "10px",
                                    }}
                                  ></i>
                                  <span
                                    className={
                                      isChartLabelBlurred
                                        ? "portfolio-sensitive-label-blurred"
                                        : ""
                                    }
                                  >
                                    {stock.scrip}
                                  </span>
                                  {stock.pdfPath && (
                                    <button
                                      type="button"
                                      className="report-icon-button ms-2"
                                      title="View report"
                                      aria-label={`View report for ${stock.scrip}`}
                                      data-bs-toggle="modal"
                                      data-bs-placement="top"
                                      data-bs-target="#pdfModal"
                                      onClick={() => setPdfPath(stock.pdfPath)}
                                    >
                                      <i
                                        className="far fa-file-pdf"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                  )}
                                  {stock.allocationList?.length > 1 && (
                                    <button
                                      type="button"
                                      className={`btn btn-sm border-0  ms-2 ${theme === "dark" ? "text-light" : "text-dark"}`}
                                      aria-label="View allocation list"
                                      data-bs-toggle="modal"
                                      data-bs-target="#allocationModal"
                                      onClick={() =>
                                        setSelectedAllocationStock({
                                          symbol: stock.scrip,
                                          allocationList: stock.allocationList,
                                        })
                                      }
                                    >
                                      <i className="fa fa-ellipsis-v"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                              {/* Qty */}
                              <div className="col-md-1 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Qty
                                    </small>
                                  </small>
                                  <span>{stock.qty}</span>
                                </div>
                              </div>
                              {/* Avg price */}
                              <div className="col-md-2 col-6">
                                <div class="text-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Avg. Price{" "}
                                    </small>
                                  </small>
                                  <span>{stock.avgPrice.toFixed(2)}</span>
                                </div>
                              </div>
                              {/* Exit Price */}
                              <div className="col-md-2 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Exit Price
                                    </small>
                                  </small>
                                  <span>{stock.exitPrice?.toFixed(2)}</span>
                                </div>
                              </div>
                              {/* Exit Date */}
                              <div className="col-md-2 col-6">
                                <div class="text-end">
                                  <small>
                                    <small class="d-block d-md-none text-muted">
                                      Exit Date{" "}
                                    </small>
                                  </small>
                                  <span>
                                    {moment(stock.exitDate).format(
                                      "DD MMM YYYY",
                                    )}
                                  </span>
                                </div>
                              </div>
                              {/* P&L */}
                              <div className="col-md-2 col-6">
                                <div class="text-start text-md-end">
                                  <small>
                                    <small className="d-block d-md-none text-muted">
                                      Booked P&L
                                    </small>
                                  </small>
                                  <span
                                    className={
                                      stock.pnl >= 0
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {stock.pnl?.toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                    })}
                                    <br />
                                    <small>
                                      ({stock.pnlPer?.toFixed(2)}%)
                                      <i
                                        className={`fa fa-caret-${stock.pnlPer >= 0 ? "up" : "down"}`}
                                      ></i>
                                    </small>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center text-muted py-4">
                    All closed recommendations and the P&L summary are displayed here.
                  </div>
                )}
              </div>
            </div>
          </section>
          <div
            className="modal fade"
            id="newModal"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div
                className="modal-content"
                style={{
                  backgroundColor: theme === "dark" ? "#000000" : "",
                  color: theme === "dark" ? "#ffffff" : "",
                }}
              >

                <div className="modal-header">
                  <h5 className="modal-title">{StockName} Corporate Actions</h5>
                  <button
                    type="button"
                    className={`btn-close ${theme === "dark" ? "btn-close-white" : ""}`}
                    data-bs-dismiss="modal"
                    onClick={() => { setStockName(null) }}
                    aria-label="Close corporate actions"
                  ></button>
                </div>

                <div className="modal-body p-0">
                  <div className=" d-flex py-2 border border-bottom">
                    {summaryNews
                      .filter((item) => Object.keys(item.CORP_SUMMARY || {}).length > 0)
                      .map((item) => (

                        <div key={item.CORPACT_ID}>
                          <button className="btn btn-sm btn-outline-primary rounded-3 ms-3 "
                            onClick={() => handleNews(item.CORPACT_ID)}
                          >
                            {item.CORP_ACTION}
                          </button>
                        </div>
                      ))}

                  </div>
                  {}
                  <div className="row ms-2 py-2">
                    <span className="text-muted">{`25 Mar 2025`}</span>
                    <div className="mb-0"> Dividend </div>
                  </div>
                  <hr />
                </div>

              </div>
            </div>
          </div>

          <PdfModal pdfPath={pdfPath} theme={theme} />
          <AllocationModal stock={selectedAllocationStock} theme={theme} />
        </>
        {/* ) : (
          
         )
        // } */}
      </div>
    </Layout>
  );
}
